export default __webpack_public_path__ + "static/media/car-cpu-1.0ef0ae67.svg";